<script>
import axios from "axios";
import Swal from "sweetalert2";
import $ from "jquery";

export default{
    name: "table-nilai-evaluasi-stula",

    data(){
        return{
            id: this.$route.params.id,
            templateExcel: '/template_excel/template_stula.xlsx',
            showModal : false,
            pathExcel:false,
            loadingTable:true,
            nilaiStula:null,

            dataTable: [],

            maxDataStula: {
                max_stula_kelompok: null,
                max_percent_kelompok: null,
                max_stula_individu: null,
                max_percent_individu: null,
                max_nilai_stula: null,
            },
            minDataStula:{
                min_stula_kelompok: null,
                min_percent_kelompok: null,
                min_stula_individu: null,
                min_percent_individu: null,
                min_nilai_stula: null,
            },
            avgDataStula: {
                avg_stula_kelompok: null,
                avg_percent_kelompok: null,
                avg_stula_individu: null,
                avg_percent_individu: null,
                avg_nilai_stula: null,
            },
        }
    },
    mounted(){
        this.getDataTableEvaluasiStula(this.id);
    },
    methods:{
    getDataTableEvaluasiStula(id) {
      let self = this;
      self.loadingTable = true;

      // get data table evaluasi stula
      var config = {
        method: "get",
        url:
          process.env.VUE_APP_BACKEND_URL_VERSION + "transactions/penilaian/evaluasi-stula",
        params: {
          id: id,
        },
        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + localStorage.access_token,
        },
      };
      console.log()
      axios(config)
        .then(function (response) {
          self.loadingTable = false;

          var response_data = response.data;
          var response_data_fix = response_data.data;

          if (response.status == 200) {
            self.dataTable = response_data_fix[0];
            console.log(response)

            self.maxDataStula.max_stula_kelompok = response_data.data[1]['max_stula_kelompok'];
            self.maxDataStula.max_percent_kelompok = response_data.data[1]['max_percent_kelompok'];
            self.maxDataStula.max_stula_individu = response_data.data[1]['max_stula_individu'];
            self.maxDataStula.max_percent_individu = response_data.data[1]['max_percent_individu'];
            self.maxDataStula.max_nilai_stula = response_data.data[1]['max_nilai_stula'];

            self.minDataStula.min_stula_kelompok = response_data.data[2]['min_stula_kelompok'];
            self.minDataStula.min_percent_kelompok = response_data.data[2]['min_percent_kelompok'];
            self.minDataStula.min_stula_individu = response_data.data[2]['min_stula_individu'];
            self.minDataStula.min_percent_individu = response_data.data[2]['min_percent_individu'];
            self.minDataStula.min_nilai_stula = response_data.data[2]['min_nilai_stula'];

            self.avgDataStula.avg_stula_kelompok = response_data.data[3]['avg_stula_kelompok'];
            self.avgDataStula.avg_percent_kelompok = response_data.data[3]['avg_percent_kelompok'];
            self.avgDataStula.avg_stula_individu = response_data.data[3]['avg_stula_individu'];
            self.avgDataStula.avg_percent_individu = response_data.data[3]['avg_percent_individu'];
            self.avgDataStula.avg_nilai_stula = response_data.data[3]['avg_nilai_stula'];


          } else {
            self.dataTable = [];
          }
        })
        .catch(function (error) {
          self.loadingTable= false;
          self.dataTable = [];
          console.log(error);
        });
    },
    importEvaluasiStula() {
      let self = this;
      self.showModal = true;
    },

    inputFileExcel() {
      let self = this;
      if ($("#inputExcelEvaluasiStula")[0].files[0]) {

        let fileName = $("#inputExcelEvaluasiStula")[0].files[0].name;
        let fileExtension = fileName.split('.').pop().toLowerCase();

        if (fileExtension === 'xlsx') {
          $("#uploadLoadingStula").html('<span class="badge bg-warning p-1"><i class="fa fa-refresh fa-spin"></i> Loading...</span>');

          var urlres = process.env.VUE_APP_BACKEND_URL;
          var FormData = require("form-data");
          var data = new FormData();
          data.append("file", $("#inputExcelEvaluasiStula")[0].files[0]);
          var config = {
            method: "post",
            url: process.env.VUE_APP_BACKEND_URL_VERSION + "referensi/upload",
            headers: {
              Authorization: "Bearer " + localStorage.access_token,
            },
            data: data,
          };
          axios(config).then(function (response) {
            var resStatus = response.status;
            if (resStatus === 200) {
              var path_file = response.data.data.path_file;
              urlres += path_file;
              $("#uploadLoadingStula").html(
                '<span class="badge bg-success p-1">' +
                '<i class="fa fa-check"></i>' +
                'Berhasil' +
                '</span>' +
                '<a href="' + urlres + '" target="_blank" style="padding-left:10px;">' +
                '<span class="badge bg-success p-1">' +
                '<i class="fa fa-eye"></i>' +
                'Lihat File' +
                '</span>' +
                '</a>'
              );

              self.pathExcel= path_file;
            } else {
              Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Something went wrong !',
                showConfirmButton: true,
              });
            }
          });
        } else {
          alert("Format file harus ber-type (XLSX)");
          $('#inputExcelEvaluasiStula').val('');
        }
      }
    },

    storeImportEvaluasiStula() {
      let self = this;
      Swal.fire({
        title: '<i class="fas fa-spinner fa-spin"></i>',
        text: 'Loading . . .',
        showConfirmButton: false,
        allowEnterKey: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
      });

      var config = {
        method: "post",
        url: process.env.VUE_APP_BACKEND_URL_VERSION + "transactions/penilaian/importEvaluasi/stula",
        data: {
          id: self.id,
          path_excel: self.pathExcel
        },
        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + localStorage.access_token
        }
      };

      axios(config).then((response) => {
        var resStatus = response.status;
        if (resStatus === 200) {
          Swal.fire({
            icon: 'success',
            title: 'Success',
            text: 'Success upload data !',
            showConfirmButton: true,
          });

          $("#inputExcelEvaluasiStula").val('');
          $("#uploadLoadingStula").empty();
          self.showModal = false;

          self.getDataTableEvaluasiStula(self.id);
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Failed',
            text: 'Something went wrong !',
            showConfirmButton: true,
          });
        }
      }).catch((error) => {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Something went wrong !\n ' + error,
          showConfirmButton: true,
        });
      });
    },
    exportEvaluasiStula() {
      let self = this;

      Swal.fire({
        title: '<i class="fas fa-spinner fa-spin"></i>',
        text: 'Loading . . .',
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
      });

      var config = {
        method: 'get',
        url: process.env.VUE_APP_BACKEND_URL_VERSION + 'transactions/penilaian/eksportEvaluasi/stula',
        params: {
          id: self.id,
        },
        crossdomain: true,
        responseType: 'blob',
        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + localStorage.access_token,
        },
        withCredentials: true,
      };

      axios(config).then((response) => {
        var resStatus = response.status;
        if (resStatus === 200) {
          Swal.close();
          // Download the file
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'Evaluasi Nilai Stula.xlsx'); // Update filename if needed
          document.body.appendChild(link);
          link.click();
        }
      }).catch((error) => {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Something went wrong !\n' + error,
          showConfirmButton: true
        });
      });
    },

    }
}
</script>

<template>
    <div class="row mt-3 mb-2">
        <div class="col-12">
        <div class="card-title">Evaluasi Stula</div>
        </div>
    </div>

    <div class="row mb-3">
        <div class="col-12 text-end">
        <b-button variant="info" size="sm" @click="importEvaluasiStula()">
            <i class="fas fa-upload"></i>
            &nbsp;
            <b>Import Evaluasi Stula</b>
        </b-button>
        &nbsp;
        <b-button variant="info" size="sm" @click="exportEvaluasiStula()">
            <i class="fas fa-file-excel"></i>
            &nbsp;
            <b>Export Evaluasi Stula</b>
        </b-button>
        </div>
    </div>

    <div class="row">
        <div class="col-12 table-responsive pb-3">
        <table class="table mb-0 mt-0 table-bordered table-condensed">
            <thead class="blueTheme align-middle">
            <tr>
                <th class="text-center" rowspan="2">NDH</th>
                <th class="text-center" rowspan="2">Nama Peserta</th>
                <th class="text-center">Penugasan Kelompok</th>
                <th class="text-center">10%</th>
                <th class="text-center">Penugasan Individu</th>
                <th class="text-center">10%</th>
                <th class="text-center" rowspan="2">Nilai Stula</th>
            </tr>
            <tr>
                <th style="max-width:150px;" class="text-center" colspan="2">Kualitas dokumentasi lesson learnt Studi Lapangan yang didukung dengan data dan informasi yang relevan</th>
                <th style="max-width:150px;" class="text-center" colspan="2">Kualitas lesson learnt adopsi dan adaptasi hasil Studi Lapangan (individual) sesuai agenda pembelajaran</th>
            </tr>
            </thead>
            <tbody class="align-top">
            <tr v-if="loadingTable == true">
                <td colspan="30">
                <i class="fas fa-spin fa-spinner"></i>
                &nbsp;
                <span>loading . . .</span>
                </td>
            </tr>
            <tr v-else-if="dataTable== ''">
                <td colspan="30" class="text-center">
                -- Data Kosong --
                </td>
            </tr>
            <tr v-else v-for="(row_data, key_data) in dataTable" :key="key_data">
                <td class="text-center">{{ key_data + 1 }}</td>
                <td>{{ row_data.user.name }}</td>
                <td class="text-center">
                <span class="numberHover" :title="row_data.user.name">
                    {{ row_data.stula_kelompok }}
                </span>
                </td>
                <td class="text-center">
                <span class="numberHover" :title="row_data.user.name">
                    {{ row_data.percent_kelompok }}
                </span>
                </td>
                <td class="text-center">
                <span class="numberHover" :title="row_data.user.name">
                    {{ row_data.stula_individu }}
                </span>
                </td>
                <td class="text-center"><span class="numberHover" :title="row_data.user.name">{{ row_data.percent_individu }}</span></td>
                <td class="text-center"><span class="numberHover" :title="row_data.user.name">{{ row_data.nilai_stula }}</span></td>
            </tr>
            <tr class="rowFooter">
                <td></td>
                <td><b>Nilai Tertinggi</b></td>
                <td class="text-center"><b>{{ maxDataStula.max_stula_kelompok }}</b></td>
                <td class="text-center"><b>{{ maxDataStula.max_percent_kelompok }}</b></td>
                <td class="text-center"><b>{{ maxDataStula.max_stula_individu }}</b></td>
                <td class="text-center"><b>{{ maxDataStula.max_percent_individu }}</b></td>
                <td class="text-center"><b>{{ maxDataStula.max_nilai_stula }}</b></td>
            </tr>
            <tr class="rowFooter">
                <td></td>
                <td><b>Nilai Terendah</b></td>
                <td class="text-center"><b>{{ minDataStula.min_stula_kelompok }}</b></td>
                <td class="text-center"><b>{{ minDataStula.min_percent_kelompok }}</b></td>
                <td class="text-center"><b>{{ minDataStula.min_stula_individu }}</b></td>
                <td class="text-center"><b>{{ minDataStula.min_percent_individu }}</b></td>
                <td class="text-center"><b>{{ minDataStula.min_nilai_stula }}</b></td>
            </tr>
            <tr class="rowFooter">
                <td></td>
                <td><b>Rata-rata</b></td>
                <td class="text-center"><b>{{ avgDataStula.avg_stula_kelompok }}</b></td>
                <td class="text-center"><b>{{ avgDataStula.avg_percent_kelompok }}</b></td>
                <td class="text-center"><b>{{ avgDataStula.avg_stula_individu }}</b></td>
                <td class="text-center"><b>{{ avgDataStula.avg_percent_individu }}</b></td>
                <td class="text-center"><b>{{ avgDataStula.avg_nilai_stula }}</b></td>
            </tr>
            </tbody>
        </table>
        </div>
        <div class="col-md-12 p-3 pb-3 text-end">
        <!-- <b-button variant="success">
            <b>Simpan Perubahan</b>
            &nbsp;
            <i class="fas fa-check"></i>
        </b-button> -->
        </div>
    </div>


    <b-modal v-model="showModal" title="Import Evaluasi Stula" title-class="text-black font-18" body-class="p-3" hide-footer>
    <form @submit.prevent="storeImportEvaluasiStula()">
      <div class="row mt-2">
        <div class="col-12 text-end">
          <a :href="templateExcel" target="_blank" class="btn btn-sm btn-success" style="border-bottom-left-radius: 0px !important; border-bottom-right-radius: 0px !important;">
            <i class="fas fa-download"></i>
            &nbsp;
            <span><b>Download Template</b></span>
          </a>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <input type="file" class="form-control" id="inputExcelEvaluasiStula" placeholder="Masukkan File Excel . . ." v-on:change="inputFileExcel()" accept=".xlsx" style="border-top-right-radius: 0px !important;">
        </div>
        <div class="col-12">
          <div class="respond-input-file float-left" id="uploadLoadingStula"></div>
        </div>
      </div>

      <div class="row mt-3 mb-2">
        <div class="col-12">
          <hr>
        </div>
      </div>

      <div class="row">
        <div class="col-12 text-end">
          <b-button variant="primary" type="submit">
            <i class="fas fa-check"></i>
            &nbsp;
            <span><b>Simpan</b></span>
          </b-button>
        </div>
      </div>
    </form>
  </b-modal>
</template>